import { useIdentity } from '@zenbusiness/application-commons-identity';
import PropTypes from 'prop-types';

import {
  NextButton,
  SummaryCardContainer, TextWithBottomSpacing
} from '#client/pages/EducationStudio/components/Interactive/WorksheetActivity/worksheetComponents';
import { useBreakpoints } from '#client/pages/EducationStudio/hooks';

import { SelectionCard } from '../../Interactive/BubbleSelectionActivity/InsideAlternative/selectionCard';
import { ExercisePage } from '../../Interactive/WorksheetActivity/exercisePage';

const NEXT_BUTTON_TEXT = 'Get started';

export const DiscoverYourArchetypes = ({ onNext }) => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const { name } = useIdentity();

  const items = [{ text: 'Archetype 1', bgColor: '#EDEDED' },
    { text: 'Archetype 2', bgColor: '#EDEDED' },
    { text: 'Archetype 3', bgColor: '#EDEDED' }];

  const presentation = (
    <SummaryCardContainer>
      <SelectionCard
        user={name}
        items={items}
      />
    </SummaryCardContainer>
  );
  const summary = (
    <TextWithBottomSpacing>
      After getting to know the creators, you can start to look at which ones resonate with you.
      Keep those creators in mind as you go through the Journey to Success.
    </TextWithBottomSpacing>
  );

  return (
    <ExercisePage
      caption="Exercise"
      title="Now let&apos;s discover your archetypes"
      summary={summary}
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      onNext={onNext}
    >
      {!isMobile && (
      <NextButton
        color="primary"
        variant="contained"
        size="large"
        onClick={() => onNext()}
      >
        {NEXT_BUTTON_TEXT}
      </NextButton>
      )}
    </ExercisePage>
  );
};

DiscoverYourArchetypes.propTypes = {
  onNext: PropTypes.func
};

DiscoverYourArchetypes.defaultProps = {
  onNext: () => {}
};

export default DiscoverYourArchetypes;
